import { observable, action, computed } from 'mobx';
import Cookies from 'universal-cookie';

import api from './api';
import FormStore from './FormStore';
import { StorageKeys } from './Storage';

const cookies = new Cookies();

class UserStore {
  constructor() {
    this.settingsForm = new FormStore(this);
  }

  @observable user;
  @observable client;
  @observable clientProfiles = [];
  @observable clientProfileOptions = [];
  @observable serviceLevel;
  @observable loading = false;
  @observable logo;
  @observable isStoreUser = false;
  @observable isReadOnly = false;
  @observable isClientAdmin = false;
  @observable clientSettings;
  @observable permissions = {};
  @observable blurCustomerInfo = false;
  @observable blurCustomerAddress = false;

  // get user
  @action async getUser() {
    await api.get('/me')
      .then(response => {
        if (response.status === 200) {
          const {client, user, service_level, permissions} = response.data;
          this.client = client;
          this.logo = client.logo_url;
          this.user = user;
          this.serviceLevel = service_level;
          this.permissions = permissions || {};
          if (user && user.scopes) {
            this.isStoreUser = user.scopes.includes('store-manager') || user.scopes.includes('store-associate');
            this.isReadOnly = user.scopes.includes('client-read-only') || user.scopes.includes('store-manager') || user.scopes.includes('store-associate');
            this.isClientAdmin = user.scopes.includes('client-admin');
          }
        }
      })
  }

  @action
  getClientProfiles(cb) {
    if (!this.clientProfiles || !this.clientProfiles.length) {
      api.get('/client-profiles').then(response => {
        if (response.ok) {
          this.clientProfiles = response.data;
          this.clientProfileOptions = response.data.map(r => ({
            label: r.name,
            value: r.id,
          }))
        } else {
          this.clientProfiles = [];
          this.clientProfileOptions = [];
        }

        if(cb) cb(response);
      })
    }
  }

  @action
  setLogo(url) {
    return this.logo = url;
  }

  @action
  getClientSettings(callback) {
    api.get("/shipments/client-settings")
      .then((response) => {
        if (response) {
          if (callback) callback(response);
          this.clientSettings = response?.data?.client_settings;
        }
      })
  }

  @computed
  get isBrandsOwner() {
    return !!this.clientProfiles.length && !!this.client && !!this.clientProfiles.filter(cp => cp.purchaser_id === this.client.id).length;
  }

  @computed
  get isClaimsEnabled() {
    return this.permissions?.enable_claims_tab === 'true' && this.clientSettings?.settings?.insurance_enabled === 'true';
  }

  @computed
  get canShowDashboards() {
    return this.clientSettings?.settings?.enable_dashboards === 'true' && this.isClientAdmin;
  }

  @computed
  get isSuperClient() {
    return this.user?.scopes?.includes('super-client');
  }

  @action
  setBlurCustomerInfo(value) {
    this.blurCustomerInfo = value;
    cookies.set(StorageKeys.BLUR, value, { path: '/' });
  }

  @action
  setBlurCustomerAddress(value) {
    this.blurCustomerAddress = value;
    cookies.set(StorageKeys.BLUR_ADDRESS, value, { path: '/' });
  }
}

export default UserStore;
